/* eslint-disable no-console */
<template>
  <div class="containerTable wrap_box_containerTable examine_wrap">
    <vxe-toolbar
      id="toolbarId_re4"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('carrierReview_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('carrierReview_batchOpenZy_button')"
          @click="openZhaoYou()"
          >同步找油网</el-button
        >
        <el-button
          v-if="getLimit('carrierReview_batchOpenAmap_button')"
          @click="selectOpenAmap()"
          >开通高德账号</el-button
        >
        <el-button v-if="reportProvince == 8" @click="funcReport()"
          >实际承运人上报</el-button
        >
        <el-button
          v-if="
            getLimit('carrierReview_batchReportDriver_button') &&
              loginkTarget != 0 &&
              !isAutomaticReport
          "
          @click="getSelectEvent()"
          >实际承运人批量上报</el-button
        >
        <el-button
          v-if="
            getLimit('carrierReview_batchReportVehicle_button') &&
              loginkTarget != 0 &&
              !isAutomaticReport
          "
          @click="getSelectEventReportVehicle()"
          >车辆批量上报</el-button
        >
        <el-button
          v-if="getLimit('carrierReview_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :cell-class-name="cellClassName"
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-style"
      @sort-change="sortList"
    >
      <!--      :checkbox-config="{highlight: true, labelField: '', checkMethod: checCheckboxkMethod2}"-->
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          min-width="150"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'authStatusExt')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="420"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authMsg"
          title="驳回原因"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authMsg"
            placeholder="请输入驳回原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="驾驶员姓名"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入驾驶员姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证有效期限"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange4"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="driverType"
          :formatter="formatterDriverType"
          title="车队/实际承运人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.driverType" placeholder="请选择">
            <el-option
              v-for="item in driverTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLicense"
          title="机动车驾驶证号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverLicense"
            placeholder="请输入机动车驾驶证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLicenseDueDate"
          title="车辆驾驶证到期日期"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column field="vehicleLicense" title="车辆行驶证档案编号" min-width="180" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.vehicleLicense" placeholder="请输入车辆行驶证档案编号" clearable />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          title="车辆行驶证到期日期"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column field="roadTransportCertificateNumber" title="道路运输证" min-width="180" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.roadTransportCertificateNumber" placeholder="请输入道路运输证" clearable />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          title="道路运输证到期日期"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange2"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'roadTransportCertificateDate')"
          />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeightCode"
          title="车辆核载质量(kg)"
          min-width="200"
        />
      <vxe-table-column>
        <vxe-table-column field="workLicense" title="道路运输从业资格证号" min-width="220" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.workLicense" placeholder="请输入道路运输从业资格证号" clearable />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="workLicenseDueDate"
          title="道路运输从业资格证到期日期"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange3"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <template v-if="listQuery.driverType != 1">
        <!-- <vxe-table-column>
          <vxe-table-column
            field="isHasTrailer"
            title="是否挂车"
            :formatter="({ cellValue }) => formatterField({ cellValue }, 'isHasTrailer')"
            min-width="100"
            sortable
          />
          <template v-slot:header>
            <el-select v-model="listQuery.isHasTrailer" placeholder="请选择" clearable>
              <el-option
                v-for="item in isHasTrailerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column field="trailerNum" title="挂车车牌号" min-width="200" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.trailerNum" placeholder="挂车车牌号" clearable />
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column field="vehicleTotalWeight" title="总质量/挂车车头整备质量(Kg)" min-width="240" sortable />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.vehicleTotalWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-input
                  v-model="listQuery.vehicleTotalWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column field="vehicleLoadWeight" title="核定载质量/准牵引总质量(Kg)" min-width="240" sortable />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.vehicleLoadWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-input
                  v-model="listQuery.vehicleLoadWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="vehicleClassificationCode"
            title="车辆分类"
            :formatter="formatterVehicleClassification"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select v-model="listQuery.vehicleClassificationCode" placeholder="请选择" clearable>
              <el-option
                v-for="item in vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
                clearable
              />
            </el-select>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column>
          <vxe-table-column
            field="vehicleLoadWeightCode"
            title="车辆核载质量(kg)"
            min-width="200"
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.vehicleLoadWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-input
                  v-model="listQuery.vehicleLoadWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            min-width="420"
            title="注册时间"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isSendLoginkExt"
            :formatter="formatterIsSendLogink"
            title="是否上报"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isSendLoginkExt"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in isSendLoginkOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="reportProvince ==8">
          <vxe-table-column
            field="isSendCyr"
            title="实际承运人是否上报省平台"
            :formatter="formatterOverload"
            min-width="200"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isSendCyr"
              clearable
              placeholder="请选择"
            >
              <el-option label="否" value="0" />
              <el-option label="是" value="1" />
            </el-select>
          </template>
        </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="vehicleIsSendLoginkExt"
            :formatter="formatterVehicleIsSendLogink"
            title="车辆上报"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.vehicleIsSendLoginkExt"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in vehicleIsSendLoginkOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="vehicleNetStatus"
            :formatter="formatterVehicleNetStatus"
            title="车辆入网"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.vehicleNetStatus"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in vehicleNetStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
      </template>
      <vxe-table-column title="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('carrierReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code, 'detail')">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierReview_audit_button') &&
                ((scope.row.authStatusExt != 3 && groupLevel == 0) ||
                  (scope.row.authStatusExt != 3 && groupLevel != 0))
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code, 'review')">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierReview_openZy_button') &&
                scope.row.authStatusExt == 3 &&
                !scope.row.cardNo
            "
            class="item"
            effect="dark"
            content="同步找油网"
            placement="top"
          >
            <vxe-button type="text" @click="openZhaoYou(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierReview_openAmap_button') &&
                scope.row.authStatusExt == 3 &&
                !scope.row.amapTrid &&
                groupLevel == 0
            "
            class="item"
            effect="dark"
            content="开通高德账号"
            placement="top"
          >
            <vxe-button type="text" @click="openAmap(scope.row)">
              <i class="el-icon-map-location" />
            </vxe-button>
          </el-tooltip>
          <!--          <el-tooltip-->
          <!--            v-if="-->
          <!--              getLimit('carrierReview_reportDriver_button') &&-->
          <!--                scope.row.authStatusExt === 3 &&-->
          <!--                scope.row.driverType != 1 &&-->
          <!--                loginkTarget != 0 &&-->
          <!--                !(scope.row.isSendLoginkExt == 1 && loginkTarget == 7) &&-->
          <!--                !(isAutomaticReport && scope.row.isSendLoginkExt != 2)-->
          <!--            "-->
          <!--            class="item"-->
          <!--            effect="dark"-->
          <!--            content="实际承运人上报"-->
          <!--            placement="top"-->
          <!--          >-->
          <!--            <vxe-button-->
          <!--              type="text"-->
          <!--              @click="reportDriverInfo(scope.row.partyCode)"-->
          <!--            >-->
          <!--              <i class="el-icon-phone" />-->
          <!--            </vxe-button>-->
          <!--          </el-tooltip>-->
          <!--          <el-tooltip-->
          <!--            v-if="-->
          <!--              getLimit('carrierReview_reportVehicleInfo_button') &&-->
          <!--                scope.row.authStatusExt === 3 &&-->
          <!--                scope.row.vehicleCode &&-->
          <!--                !(scope.row.vehicleIsSendLoginkExt == 1 && loginkTarget == 7) &&-->
          <!--                scope.row.driverType != 1 &&-->
          <!--                loginkTarget != 0 &&-->
          <!--                !(isAutomaticReport && scope.row.vehicleIsSendLoginkExt != 2)-->
          <!--            "-->
          <!--            class="item"-->
          <!--            effect="dark"-->
          <!--            content="车辆上报"-->
          <!--            placement="top"-->
          <!--          >-->
          <!--            <vxe-button-->
          <!--              type="text"-->
          <!--              @click="reportVehicleInfo(scope.row.vehicleCode)"-->
          <!--            >-->
          <!--              <i class="el-icon-phone-outline" />-->
          <!--            </vxe-button>-->
          <!--          </el-tooltip>-->
          <el-tooltip
            v-if="
              getLimit('carrierReview_checkTruckExist_button') &&
                scope.row.authStatusExt === 3 &&
                scope.row.driverType === 0 &&
                scope.row.vehicleNetStatus === 0
            "
            class="item"
            effect="dark"
            content="入网验证"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcCheckTruckExist(scope.row.vehicleLicenseNumber)"
            >
              <i class="el-icon-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierReview_lockCar_button') &&
                scope.row.authStatusExt === 3 &&
                scope.row.isFreezeExt != 1
            "
            effect="dark"
            content="冻结"
            placement="top"
          >
            <vxe-button type="text" @click="lockCar(scope.row)">
              <i class="el-icon-lock" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('carrierReview_unlockCar_button') &&
                scope.row.authStatusExt === 3 &&
                scope.row.isFreezeExt === 1
            "
            effect="dark"
            content="解除冻结"
            placement="top"
          >
            <vxe-button type="text" @click="unlockCar(scope.row)">
              <i class="el-icon-unlock" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 详情  详情-->
    <vxe-modal
      title=" --"
      v-model="driverFlag"
      width="1400"
      height="800"
      resize
    >
      <driverDetail
        ref="detailRef"
        :title="modalTitle"
        :parent-data="parentData"
        @fatherMethods="fatherMethods"
      />
    </vxe-modal>
    <!-- 报文 -->
    <vxe-modal
      v-model="datagramFlag"
      title="报文详情"
      width="900"
      height="600"
      resize
    >
      <datagramDetail ref="datagramRef" :parent-data="parentData" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import driverDetail from "./components/driverDetail.vue";
import datagramDetail from "./components/datagramDetail.vue";
import { getListDict } from "@/api/commonApi";
import {
  updateAuthStatus,
  getDriverTeamList,
  openZhaoYou,
  reportDriverInfo,
  checkTruckExist,
  openAmap,
  reportVehicleInfo,
  freezeDriver,
  unfreezeTeamDriver
} from "@/api/driver";
export default {
  name: "CarrierReview",
  components: {
    driverDetail,
    datagramDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportDriverAuth", //导出接口
        name: "实际承运人审核"
      },
      exportableQuantity: localStorage.getItem("exportableQuantity"),
      exportableUrl: "ntocc-basic-api/driver/exportDriverAuth",
      modalTitle: "详情",
      parentData: {
        isDetail: true,
        areaOptions: this.$store.state.components.areaOptions,
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleLicenseColorList: [],
        vehicleEnergyTypeList: [],
        receiverUserCodeOptions: [],
        typeOptions: [],
        bankOptions: []
      },

      loading: false,
      tableData: [],
      driverFlag: false,
      datagramFlag: false,
      formatterOverload({ cellValue }) {
        switch (cellValue) {
          case 1:
            return "是";
          case 0:
            return "否";
          default:
            return "";
        }
      },
      groupLevel: 0,
      listQuery: {
        driverLicenseDueDateRange: "",
        driverLicenseDueDateRange1: "",
        driverLicenseDueDateRange2: "",
        driverLicenseDueDateRange3: "",
        driverLicenseDueDateRange4: "",
        gmtCreatedRange: "",
        authTimeRange: "",
        branchCodeExt: "",
        authStatus: "",
        authStatusExt: "",
        isFreezeExt: "",
        name: "",
        phone: "",
        driverType: 0,
        identificationNumber: "",
        balanceStart: "",
        balanceEnd: "",
        gmtCreatedEnd: "",
        gmtCreatedStart: "",
        driverLicenseDueDateStart: "",
        driverLicenseDueDateEnd: "",
        driverLicenseFromDateStart: "",
        driverLicenseFromDateEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        balance: 0
      },
      // 审核状态
      authStatusExtOptions: [
        {
          label: "未审核",
          value: 0
        },
        // {
        //   label: "审核中",
        //   value: 1
        // },
        {
          label: "审核驳回",
          value: 2
        },
        {
          label: "审核通过",
          value: 3
        }
      ],
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 实际承运人/车队类型
      driverTypeOptions: [
        {
          label: "全部",
          value: 6
        },
        {
          label: "独立实际承运人",
          value: 0
        },
        {
          label: "车队",
          value: 1
        }
      ],
      //
      isSendLoginkOptions: [
        {
          label: "未上报",
          value: 0
        },
        {
          label: "已上报",
          value: 1
        },
        {
          label: "上报失败",
          value: 2
        }
      ],
      vehicleIsSendLoginkOptions: [
        {
          label: "未上报",
          value: 0
        },
        {
          label: "已上报",
          value: 1
        },
        {
          label: "上报失败",
          value: 2
        }
      ],
      //车辆入网
      vehicleNetStatusOptions: [
        {
          label: "未入网",
          value: 0
        },
        {
          label: "已入网",
          value: 1
        }
      ],
      loginkTarget: 0,
      vehicleClassificationList: [],
      vehicleTonnageList: [],
      reportProvince: ""
    };
  },
  computed: {
    ...mapState({
      isAutomaticReport: state => state.user.party.isAutomaticReport
    }),
    /**
     * 将“parentData”对象下的属性“model”返回为当前组件属性便于监控
     */
    model() {
      return this.parentData.model;
    }
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.authStatusExt = 0;
      } else {
        this.listQuery.authStatusExt = "";
      }
      this.findList();
    },
    model(val) {
      this.modalTitle = val === "review" ? "审核" : "详情";
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.authStatusExt = 0;
    }
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.reportProvince =
      dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue;
    this.loginkTarget = dataBranch.partyGroupConfigCacheMap
      .loginkTarget_reportProvince
      ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
          .configValue
      : 0;
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({
      types:
        "vehicleTypeAllow,vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor"
    }).then(response => {
      this.parentData.vehicleTypeAllowList = response.data.filter(
        item => item.type === "vehicleTypeAllow"
      )[0]["dictList"];
      this.parentData.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.vehicleLengthList = response.data.filter(
        item => item.type === "vehicleLength"
      )[0]["dictList"];
      this.parentData.vehicleWidthList = response.data.filter(
        item => item.type === "vehicleWidth"
      )[0]["dictList"];
      this.parentData.vehicleHighList = response.data.filter(
        item => item.type === "vehicleHigh"
      )[0]["dictList"];
      this.parentData.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.parentData.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.parentData.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      this.parentData.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.findList();
    });
    this.groupLevel = JSON.parse(localStorage.getItem("dataBranch")).level;
    this.listQuery.branchCodeExt = JSON.parse(
      localStorage.getItem("dataBranch")
    ).code;
  },
  mounted() {},
  methods: {
    // 类型筛选
    formatterDriverType({ cellValue }) {
      let item = this.driverTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterIsSendLogink({ cellValue }) {
      let item = this.isSendLoginkOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterVehicleIsSendLogink({ cellValue }) {
      let item = this.vehicleIsSendLoginkOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getDriverTeamList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情
    funcEdit(code, prefix) {
      this.driverFlag = true;
      this.$refs.detailRef.getDriver(code);
      this.$set(this.parentData, "model", prefix);
    },
    // 报文详情
    funcSendDataGram(code) {
      this.datagramFlag = true;
      this.$refs.datagramRef.getDriver(code);
    },
    fatherMethods() {
      this.driverFlag = false;
      this.findList();
    },
    //同步找油网
    openZhaoYou(row) {
      const selectRecords = row ? [row] : this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        return this.$message({ message: "请选择实际承运人", type: "warning" });
      } else if (selectRecords.length > 100) {
        return this.$message({
          message: "批量处理最多100条数据",
          type: "warning"
        });
      } else {
        let codes = [];
        for (let item of selectRecords) {
          if (item.authStatusExt != 3) {
            return this.$message.warning("请选择审核通过的实际承运人");
          }
          if (item.cardNo) {
            return this.$message.warning("实际承运人已同步");
          }
          codes.push(item.partyCode);
        }
        codes = codes.join(",");
        this.$confirm("确认同步找油网？")
          .then(_ => {
            const rLoading = this.openLoading();
            openZhaoYou({ partyCode: codes }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      }
    },
    //开通高德账号
    openAmap(row) {
      this.$confirm("确认开通高德账号？")
        .then(_ => {
          openAmap({ partyCodes: row.partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译车辆入网
    formatterVehicleNetStatus({ cellValue }) {
      const item = this.vehicleNetStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 上报实际承运人
    reportDriverInfo(c) {
      this.$confirm("确认上报监管平台吗？").then(_ => {
        const codes = c;
        const rLoading = this.openLoading();
        this.$refs.xTable.clearCheckboxRow();
        reportDriverInfo({ codes }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 实际承运人上报
    funcReport() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
        if (isTeamArray.length) {
          this.$message({ message: "请勿选择车队", type: "warning" });
          return false;
        }
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          updateAuthStatus({ driverCodes: codes, sendType: 1 })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.findList();
            });
        });
      }
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
        if (isTeamArray.length) {
          this.$message({ message: "请勿选择车队", type: "warning" });
          return false;
        }
        const codes = selectRecords.map(item => item.partyCode).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          reportDriverInfo({ codes })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.findList();
            });
        });
      }
    },
    // 上报车辆
    reportVehicleInfo(c) {
      this.$confirm("确认上报监管平台吗？").then(_ => {
        const codes = c;
        const rLoading = this.openLoading();
        reportVehicleInfo({ codes })
          .then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          })
          .finally(() => {
            this.findList();
          });
      });
    },
    getSelectEventReportVehicle() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择车辆", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
        if (isTeamArray.length) {
          this.$message({ message: "请勿选择车队", type: "warning" });
          return false;
        }
        const codes = selectRecords.map(item => item.vehicleCode).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          reportVehicleInfo({ codes })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.findList();
            });
        });
      }
    },
    selectOpenAmap() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择实际承运人", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        /*        const isTeamArray = selectRecords.filter(item => item.driverType === 1);
                  if (isTeamArray.length) {
                    this.$message({ message: "请勿选择车队", type: "warning" });
                    return false;
                  }*/
        const codes = selectRecords.map(item => item.partyCode).join(",");
        this.$confirm("确认开通高德账号？").then(_ => {
          const rLoading = this.openLoading();
          openAmap({ partyCodes: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
            rLoading.close();
          });
        });
      }
    },
    // 冻结
    lockCar(row) {
      this.$confirm("确认冻结吗？")
        .then(_ => {
          freezeDriver({ partyCode: row.partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 解除冻结
    unlockCar(row) {
      this.$confirm("确认解除冻结吗？")
        .then(_ => {
          unfreezeTeamDriver({ partyCode: row.partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 入网验证
    funcCheckTruckExist(c) {
      this.$confirm("确认验证吗？").then(_ => {
        const carNum = c;
        const rLoading = this.openLoading();
        checkTruckExist({ carNum }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "balance") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      const overDueType = row.overDueType || [];
      //驾驶证
      if (column.property === "driverLicenseDueDate") {
        if (overDueType.indexOf("driver") > -1) {
          return "col-red";
        }
      }
      //形驶证
      if (column.property === "vehicleLicenseDueDate") {
        if (overDueType.indexOf("vehicle") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "workLicenseDueDate") {
        if (overDueType.indexOf("work") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "roadTransportCertificateDate") {
        if (overDueType.indexOf("road") > -1) {
          return "col-red";
        }
      }
      //身份证
      if (column.property === "idCardDueDate") {
        if (overDueType.indexOf("idCard") > -1) {
          return "col-red";
        }
      }
    },
    checCheckboxkMethod2({ row }) {
      return row.isSendLoginkExt != 1;
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.vehicleClassificationList.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    }
  }
};
</script>
<style lang="scss">
.wrap_box_containerTable {
  .vxe-modal--title {
    opacity: 0;
  }
}
</style>
<style scoped>
.examine_wrap {
  padding: 20px;
}
.mytable-style .vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
/* eslint-enable no-console */
